import { Filter } from '@cubejs-client/core';
import { IAnalyticsActivityEnum } from '../../../../common/enum/analytics-activity/analytics-activity.enum';
import { LogManager } from '../../../../common/port/log/log.manager.port';
import { CubeAdapter } from '../../../../infrastructure/adapters/cube/cube.adapter';
import {
  ISelfInteractionsGoalPersistenceResponse,
  SelfInteractionsGoalMapper,
} from '../../../../infrastructure/mappers/goals/self-interactions-goal.mapper';
import { GetSelfGoalSummaryRequestDto } from '../../../../interface/dtos/goals/get-self-goal-summaries.request.dto';
import { SelfInteractionsGoalEntity } from '../../../domain/entities/goals/app-goals/self-interactions-goal.entity';

export class GetSelfInteractionsGoalService {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly adapter: CubeAdapter,
    protected readonly mapper: SelfInteractionsGoalMapper
  ) {}

  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfInteractionsGoalEntity> {
    try {
      const filters: Filter[] = [
        {
          member: IAnalyticsActivityEnum.AppId,
          operator: 'equals',
          values: [props.goal.appId],
        },
      ];
      if (props.goal.appCategoryId) {
        filters.push({
          member: IAnalyticsActivityEnum.AppCategoryId,
          operator: 'equals',
          values: [props.goal.appCategoryId],
        });
      }

      const [response]: ISelfInteractionsGoalPersistenceResponse[] =
        await this.adapter.query(props.config.token, {
          measures: [IAnalyticsActivityEnum.Count],
          timeDimensions: [
            {
              dimension: IAnalyticsActivityEnum.LocalStartTime,
              dateRange: [props.goal.startDate, props.goal.endDate],
            },
          ],
          filters,
        });

      const entity = response?.[IAnalyticsActivityEnum.Count]
        ? this.mapper.toDomain(response)
        : SelfInteractionsGoalEntity.create({
            appMetric: 0,
          });
      entity.setGoalValue(Number(props.goal.value));
      return entity;
    } catch (error) {
      throw new Error(
        `GetSelfInteractionsGoalService.execute encountered an error ${error}`
      );
    }
  }
}
